import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import { StyledH3 } from '../TextPageLandlord/TextPageLandlord.styles';

const AffittareOnline = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Affittare online in tutta sicurezza
      </StyledH3>
      <TextBody>
        Inserire annunci di affitto casa gratis e concedere un appartamento in
        locazione, attraverso trattative semplici e veloci è già un vantaggio.
        <strong>
          Carica informazioni precise sul tuo immobile o sulla stanza che vuoi
          affittare
        </strong>{' '}
        e inserisci numerose foto permettano di osservarne i dettagli ed
        esplorarne l’intera superficie da ogni angolazione. In questo modo il
        potenziale inquilino avrà un’idea più precisa dell’alloggio da te
        proposto anche senza muoversi da casa.
      </TextBody>
      <TextBody>
        Aggiungendo questa opportunità, chiunque fosse interessato a prendere in
        affitto il tuo immobile, potrà visionare il tuo appartamento senza
        spostarsi con un effetto sorprendentemente realistico ed efficace. E
        tutto ciò senza alcun costo, perché{' '}
        <strong>
          Zappyrent è attualmente l’unico operatore sul mercato immobiliare che
          offre alla sua clientela un servizio di annunci immobiliari in maniera
          completamente gratuita.
        </strong>
        Ricordati infine, di rendere disponibile l’alloggio a visite fisiche
        qualora l’inquilino volesse visionare in loco l’appartamento o la stanza
        che gli interessa prima di decidere di procedere alla prenotazione
        effettiva.
      </TextBody>
    </>
  );
};

export default AffittareOnline;
